<!--
@Time : 2020/11/28 7:26 下午
@Author : yekong
@File : zhishu.vue
@Software : PhpStorm
-->
<template>
  <div class="zhishus">
    <div class="zhishutitle">
      <titles title="2019年总指数"></titles>
    </div>
    <div class="zhishu">
      <div class="zhishubody">
        <span>95分</span>
      </div>
    </div>
    <div class="list">
      <div class="item">
        <p>企业全生命周期</p>
        <div class="jindu">
          <img class="c1" src="../../assets/lingxing1.png" alt="">
          <div class="jindu1s" :style="{width:400*0.7+'px'}">70%</div>
          <img class="c2" src="../../assets/lingxing1.png" alt="">
        </div>
      </div>
      <div class="item">
        <p>投资吸引力</p>
        <div class="jindu jindu2">
          <img class="c1" src="../../assets/lingxing2.png" alt="">
          <div class="jindu2s" :style="{width:400*0.3+'px'}">30%</div>
          <img class="c2" src="../../assets/lingxing2.png" alt="">
        </div>
      </div>
      <div class="item">
        <p>监管与服务</p>
        <div class="jindu jindu3">
          <img class="c1" src="../../assets/lingxing3.png" alt="">
          <div class="jindu3s" :style="{width:400*0.3+'px'}">30%</div>
          <img class="c2" src="../../assets/lingxing3.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import titles from "@/components/title";

export default {
  name: "zhishu",
  components: {titles},
  data: function () {
    return {
      number1: 30,
      number2: 50,
      number3: 70,
    }
  },
  props: {
    top: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  created: function () {

  },
  filters: {},
  methods: {},
  mounted() {
  },
}
</script>

<style lang="scss" scoped>
@import "../../main";

.zhishu {
  width: 837px;
  height: 217px;
  background: url("../../assets/zhishuzuo.png") top left no-repeat,
  url("../../assets/zhishuyou.png") bottom right no-repeat;
  @include flex_center_center();

  .zhishubody {
    width: 814px;
    height: 195px;
    background: #2A376E;
    @include flex_center_center();

    span {
      font-size: 124px;
      font-family: PingFang;
      font-weight: 800;
      color: #39F9FF;
    }
  }
}

.zhishutitle {
  width: 800px;
}

.list {
  .item {
    height: 100px;
    @include flex_start_center();

    p {
      font-size: 48px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      width: 380px;
    }

    .jindu1 {

    }
  }
}

.zhishus {
  margin-bottom: 80px;
}

.jindu {
  @include flex_start_center();

  img.c1 {
    position: relative;
    margin-right: -31.5px;
    z-index: 1;
  }

  img.c2 {
    position: relative;
    margin-left: -31.5px;
    z-index: 1;
  }

  .jindu1s {
    width: 192px;
    height: 63px;
    position: relative;
    background: #42aab5;
    @include flex_start_center();
    font-size: 28px;
    font-family: PingFang;
    font-weight: 800;
    color: #FFFFFF;
    text-indent: 50px;

  }

  .jindu2s {
    min-width: 150px;
    height: 63px;
    position: relative;
    background: rgba(229, 116, 68, 1);
    font-size: 28px;
    font-family: PingFang;
    font-weight: 800;
    color: #FFFFFF;
    text-indent: 50px;
    @include flex_start_center()
  }

  .jindu3s {
    min-width: 150px;
    height: 63px;
    position: relative;
    background: rgba(57, 124, 247, 1);
    font-size: 28px;
    font-family: PingFang;
    font-weight: 800;
    text-indent: 50px;
    color: #FFFFFF;
    @include flex_start_center()
  }
}
</style>
